import { OperationsListItem, OperationsSearchModel } from './types-store';

export const ACTION = {
  CLEAR_LIST: 'OPERATIONS_LIST:CLEAR_LIST',

  REQUEST_OPERATIONS_LIST: 'OPERATIONS_LIST:REQUEST_OPERATIONS_LIST',
  RECEIVE_OPERATIONS_LIST: 'OPERATIONS_LIST:RECEIVE_OPERATIONS_LIST',
  FAIL_OPERATIONS_LIST: 'OPERATIONS_LIST:FAIL_OPERATIONS_LIST',

  REQUEST_UPDATE_OPERATIONS: 'OPERATIONS_LIST:REQUEST_UPDATE_OPERATIONS',
  RECEIVE_UPDATE_OPERATIONS: 'OPERATIONS_LIST:RECEIVE_UPDATE_OPERATIONS',
  FAIL_UPDATE_OPERATIONS: 'OPERATIONS_LIST:FAIL_UPDATE_OPERATIONS'
};

export class ClearList {
  public type: string = ACTION.CLEAR_LIST;
  constructor(public requestId: number) { }
}

export class RequestOperationsList {
  public type: string = ACTION.REQUEST_OPERATIONS_LIST;
  constructor(public requestId: number, public model: OperationsSearchModel) { }
}

export class ReceiveOperationsList {
  public type: string = ACTION.RECEIVE_OPERATIONS_LIST;
  constructor(public requestId: number, public list: OperationsListItem[], public numberOfResults: number) { }
}

export class FailOperationsList {
  public type: string = ACTION.FAIL_OPERATIONS_LIST;
  constructor(public requestId: number) { }
}

export class RequestUpdateOperations {
  public type: string = ACTION.REQUEST_UPDATE_OPERATIONS;
  constructor(public listItems: OperationsListItem[]) { }
}

export class ReceiveUpdateOperations {
  public type: string = ACTION.RECEIVE_UPDATE_OPERATIONS;
}

export class FailUpdateOperations {
  public type: string = ACTION.FAIL_UPDATE_OPERATIONS;
  constructor(public id: number) { }
}
